import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  form: { width: '70%', [theme.breakpoints.down('sm')]: { width: '100%' } },
  title: { marginBottom: '5%' }
}))
